import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import CantidadEstudiantes from "../../components/Form/Fields/CantidadEstudiantes";
import CaracteristicasEspacio from "../../components/Form/Fields/CaracteristicasEspacio";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionActividad from "../../components/Form/Fields/DuracionActividad";
import TemaEvaluacion from "../../components/Form/Fields/TemaEvaluacion";
import ActividadesAplicacionCardImg from "../../components/UmmIApps/Cards/ActividadesAplicacionCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const ActividadesAplicacionPage = () => {

  const {
    nivelId,
    materiaId,
    mostrarCamposAvanzados,
    promptData,
    handleBack,
    setTextoInicial,
    toggleCamposAvanzados,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema_evaluacion &&
    isOAAdded
  );
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      nivel: "",
      materia: "",
      objetivos: [],
      tema_evaluacion: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
      caracterizacion: "",
      duracion: 5,
      caracteristicas_espacio: "",
      cantidad_estudiantes: 1,
    };
    handleInitialPromptData(init, "actividades_aplicacion");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ActividadesAplicacionCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Actividades de aplicación"
        description="Crea actividades de evaluación que inviten a los estudiantes a aplicar sus conocimientos y habilidades, promoviendo una comprensión profunda y significativa de los contenidos."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <>
          <Grid item xs={12} lg={12} display="flex" flexDirection="row">
            <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
              <GetNiveles
                onNivelChange={handleNivelChange}
                selectedNivel={nivelId}
              />
            </Grid>

            {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
            <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
              <GetAsignaturas
                nivelId={nivelId}
                onAsignaturaChange={handleAsignaturaChangeLocal}
                selectedAsignatura={materiaId}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <GetObjetivosAprendizaje
              nombreAsignatura={promptData.materia}
              nombreNivel={promptData.nivel}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3 }}>
            <TemaEvaluacion />
          </Grid>
          <Grid item xs={12}>
            <DuracionActividad />
          </Grid>
          <Grid item xs={12}>
            <CantidadEstudiantes />
          </Grid>

          <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
            <Button
              variant="text"
              sx={{ color: "#336B87" }}
              onClick={toggleCamposAvanzados}
              endIcon={
                mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
              }
            >
              {mostrarCamposAvanzados
                ? "Ocultar opciones avanzadas"
                : "Mostrar opciones avanzadas (opcional)"}
            </Button>
          </Grid>
          {/* Campos avanzados */}
          {mostrarCamposAvanzados && (
            <>
              <Grid item xs={12}>
                <CondicionesContexto />
              </Grid>
              <Grid item xs={12}>
                <Caracterizacion />
              </Grid>
              <Grid item xs={12}>
                <AdaptacionesCurriculares />
              </Grid>

              <Grid item xs={12}>
                <CaracteristicasEspacio />
              </Grid>
            </>
          )}
        </>
      </UmmiaAppsLayout>
    </>
  );
};

export default ActividadesAplicacionPage;
